import React, { useEffect } from "react"
import { Grid } from "@mui/material"

import { DateRangePicker, UsersAutocomplete } from "@components/CommonFilters/@components"
import {BACKEND_APIS, DATE_PRESETS} from "@constants"
import {companyUsers, dateRange, userData} from "@signals"
import {AppButtonIcon} from "../../../@components";
import {formatDate, postExcel} from "@ui-seeker/utils";


export default function SearchAnalyticsFilters() {

	useEffect(() => {
		dateRange.value = [new Date(new Date().setDate(new Date().getDate() - 7)), new Date()]
	}, [])

	return <Grid container spacing={2} sx={{ my: 2 }}>
		<Grid item xs={2}>
			<UsersAutocomplete/>
		</Grid>
		<Grid item xs={2}>
			<DateRangePicker sx={{ height: 2, width: "100%" }} ranges={DATE_PRESETS}/>
		</Grid>
		<Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
			<AppButtonIcon
				icon='file-excel'
				tooltip='Download dashboard excel'
				iconWeight='solid'
				iconProps={{
					color: 'success.dark',
					fontSize: 20
				}}
				onClick={ () => postExcel(`${BACKEND_APIS.SEARCH_ANALYTICS_EXCEL}`, {
					user: userData.value.username,
					uid: companyUsers.value,
					startBookingDate: formatDate(dateRange.value[0], { format: 'yyyy-MM-dd' }),
					endBookingDate: formatDate(dateRange.value[1], { format: 'yyyy-MM-dd' })
				})}
			/>
		</Grid>
	</Grid>
}